import { Route } from 'src/routes/Route'

export const SignUpRoute = Route({ path: '/sign-up' })
export type SignUpRoute = Route<typeof SignUpRoute>
